import { createFileRoute } from '@tanstack/react-router'

import { Authorisation } from "@/lib/auth/components/auth-provider";
import Unauthorized from "@/lib/auth/components/unauthorized";
import { ROLES } from "@/lib/auth/roles";
import DateFilter from '@/lib/filters/date/date-filter'
import { isCurrentPage, validateSearchWithDefaults } from '@/lib/utils'
import Performance from "@/modules/elevation-dashboard";
import ServiceTypeSelector from '@/modules/elevation-dashboard/components/service-type-selector'
import {
  questionsBreakdownAllQueryOptions,
  questionsBreakdownByMetricQueryOptions
} from '@/modules/elevation-dashboard/hooks'
import { FirmPerformanceSearch, mergedFirmPerformanceSearchSchema } from "@/types/route-search-schemas";
import { DataLoader } from '@/types/router-context'
import { ELEVATION_FIRM_PERFORMANCE_PATH, ELEVATION_FIRM_PERFORMANCE_URL } from "@/utils/urls";

export const Route = createFileRoute(ELEVATION_FIRM_PERFORMANCE_PATH)({
  component: FirmPerformance,
  loader: ({ context: { queryClient, date, roles, serviceType } }: DataLoader) => {
    if (isCurrentPage(ELEVATION_FIRM_PERFORMANCE_URL)) {
      return
    }
    if (roles.includes(ROLES.ROLE_ELEVATION) && serviceType) {
      queryClient.prefetchQuery(questionsBreakdownAllQueryOptions(date, serviceType, null))
      queryClient.prefetchQuery(questionsBreakdownByMetricQueryOptions(date, 1, serviceType, null))
      queryClient.prefetchQuery(questionsBreakdownByMetricQueryOptions(date, 2, serviceType, null))
      queryClient.prefetchQuery(questionsBreakdownByMetricQueryOptions(date, 3, serviceType, null))
    }
  },
  validateSearch: (search: Record<string, unknown>): FirmPerformanceSearch => validateSearchWithDefaults(mergedFirmPerformanceSearchSchema, search),
  beforeLoad: () => {
    return {
      breadcrumbs: [
        { label: 'Firm Performance', path: '#' },
        { label: 'Overview', path: '/' }
      ],
      children: <div className = 'flex flex-col xl:flex-row items-start sm:items-end gap-2'>
        <div className="flex flex-end items-start xs:items-center gap-2 flex-col xs:flex-row">
          <ServiceTypeSelector />
          <DateFilter />
        </div>
      </div>
    }
  },
})

function FirmPerformance() {
  return (
    <div className='flex flex-col items-center justify-center p-8 sm:p-0'>
      <Authorisation roles={[ROLES.ROLE_ELEVATION]} permissions={[]} forbiddenFallback={<Unauthorized />}>
        <Performance />
      </Authorisation>
    </div>
  )
}
